import { makeStyles, createStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { hosts } from "../../../yoello-lib/modules/host/Hosts";
import { useSignup } from "../state/SelfSignup";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      color: "#616161",
      padding: "0.25rem",
      marginTop: "1rem",
    },
    email: {
      color: "#212121",
      fontWeight: 600,
      margin: "1.25rem 0 1.25rem 0",
    },
  })
);

export function LeadCompleted() {
  const classes = useStyles();
  const { leadData, removeSnapshot, completeSignup, host } = useSignup();
  const { t } = useTranslation();
  const isWorldpay = host === hosts.worldpay;

  useEffect(() => {
    removeSnapshot();
    completeSignup();
    //eslint-disable-next-line
  }, []);

  return (
    <div className={classes.root}>
      <div>{t("signup.completed.leadText")}</div>
      <div className={classes.email}>{leadData?.contact_email}</div>
      {isWorldpay && <div className={classes.email}>{t("signup.completed.worldpayText")}</div>}
    </div>
  );
}
